

export function studentPage(value){
    if (value.role === "student"){
        return value.label
    }
}

export function teacherPage(value){
    if (value.role === "teacher"){
        return value.label
    }
}
